import React, { FunctionComponent } from "react";
import "../../assets/styles/keycloack/patternfly.min.css";
import "../../assets/styles/keycloack/patternfly(1).min.css";
import "../../assets/styles/keycloack/patternfly-additions.min.css";
import "../../assets/styles/keycloack/pficon.css";
import "../../assets/styles/keycloack/stylelogin.css";

const Login: FunctionComponent = () => {
  return (
    <div className="login-pf">
      <div className="login-pf-page">
        <div className="card-pf">
          <header className="login-pf-header">
            <h1 id="kc-page-title">Redirecting to login page...</h1>
          </header>
        </div>
      </div>
    </div>
  );
};

export default Login;